import { FooterWidgetElement } from './define-footer-element';

export function registerFooterWidget(tagName = 'adipa-footer-widget'): void {
  if (typeof customElements === 'undefined') return;
  if (customElements.get(tagName)) return;
  customElements.define(tagName, FooterWidgetElement);
}
